<!--
 * @Author: ningbo.kang
 * @Date: 2019-10-28 16:44:36
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-04-07 13:53:00
 * @FilePath: /template/src/layouts/HeaderAsideLayout/components/tools/UserNav.vue
 * @Description: 描述
 -->
<template>
  <a-menu mode="horizontal"
    :defaultSelectedKeys="current"
    class="fb-1">
    <a-menu-item v-for="(nav) in navs"
      :key="nav.id"
      @click="handleClick(nav)">
      <IconMenu v-if="nav.icon"
        :type="nav.icon"
        style="font-size:18px;" />{{nav.name}}
    </a-menu-item>
  </a-menu>
</template>
<script>
export default {
  props: {
    // 导航菜单数组
    navs: {
      type: Array,
      default: () => [],
      required: false,
    },
    // 当前选中项
    current: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(nav) {
      this.$emit('click', nav);
    },
  },
};
</script>

<style lang="less">
@import '../index.less';

.ant-layout-header .ant-menu.ant-menu-horizontal {
  line-height: @layout-header-height;
  .ant-menu-item {
    margin: 0 16px;
  }
}
.ant-layout-header {
  z-index: 31;
  .ant-menu-item-selected {
    // background: @primary-color;
    // color: #fff !important;
    &:hover {
      // background: @primary-color !important;
    }
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      border-bottom: 2px solid @primary-color;
      opacity: 1;
    }
  }
  .ant-menu-light.ant-menu-horizontal > .ant-menu-item,
  .ant-menu-light.ant-menu-horizontal > .ant-menu-submenu {
    top: 0;
    margin-top: 0;
    border-color: #001529;
    border-bottom: 0;
    border-bottom-width: 0px;
    border-bottom-style: initial;
    border-bottom-color: initial;
  }
  .ant-menu-horizontal {
    border-bottom: none;
  }
}
</style>
